import React, { useState } from 'react';
import UnidadesPage from './components/UnidadesPage';
import GruposPage from './components/GruposPage';
import ProdutosPage from './components/ProdutosPage';
import API_URL from './config';
import LoginPage from './components/LoginPage';
import SelecionarEmpresaPage from './components/SelecionarEmpresaPage';
import MenuPrincipalPage from './components/MenuPrincipalPage';
import MenuProdutosPage from './components/MenuProdutosPage';
import MenuRelatoriosPage from './components/MenuRelatoriosPage';
import RelatorioMobtefPage from './components/RelatorioMobtefPage';
import RelatorioMobtefPlanilhaPage from './components/RelatorioMobtefPlanilhaPage';
import MenuVendasPage from './components/MenuVendasPage';
import AtendimentosPage from './components/AtendimentosPage';
import PedidosPage from './components/PedidosPage';
import MenuConfiguracoesPage from './components/MenuConfiguracoesPage';

const PAGE_SIZE = 20;

function App() {
  const [usrCodigo, setUsrCodigo] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [empresas, setEmpresas] = useState([]);
  const [usuario, setUsuario] = useState(null);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [pagina, setPagina] = useState(1);
  const [paginaProdutos, setPaginaProdutos] = useState(false);
  const [paginaProdutosCrud, setPaginaProdutosCrud] = useState(false);
  const [paginaUnidades, setPaginaUnidades] = useState(false);
  const [paginaGrupos, setPaginaGrupos] = useState(false);
  const [pesquisaEmpresa, setPesquisaEmpresa] = useState('');
  const [paginaRelatorios, setPaginaRelatorios] = useState(false);
  const [paginaMobtef, setPaginaMobtef] = useState(false);
  const [paginaMobtefPlanilha, setPaginaMobtefPlanilha] = useState(false);
  const [paginaVendas, setPaginaVendas] = useState(false);
  const [paginaAtendimentos, setPaginaAtendimentos] = useState(false);
  const [paginaPedidos, setPaginaPedidos] = useState(false);
  const [paginaConfiguracoes, setPaginaConfiguracoes] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usr_codigo: usrCodigo, senha })
      });
      const data = await response.json();
      if (response.ok) {
        setUsuario(data.usuario);
        const empresasOrdenadas = [...data.empresas].sort((a, b) => a.fantasia.localeCompare(b.fantasia));
        setEmpresas(empresasOrdenadas);
        setUsrCodigo('');
        setSenha('');
        setPagina(1);
        if (empresasOrdenadas.length === 1) {
          setEmpresaSelecionada(empresasOrdenadas[0]);
        }
      } else {
        setErro(data.error || 'Usuário ou senha inválidos');
      }
    } catch (err) {
      setErro('Erro ao conectar com o servidor');
    }
    setLoading(false);
  };

  const handleSelecionarEmpresa = (empresa) => {
    setEmpresaSelecionada(empresa);
    setPaginaProdutos(false);
  };

  const handleVoltar = () => {
    if (paginaProdutos) {
      setPaginaProdutos(false);
    } else {
      setEmpresaSelecionada(null);
    }
  };

  const handleSair = () => {
    setUsuario(null);
    setEmpresas([]);
    setEmpresaSelecionada(null);
    setPagina(1);
    setUsrCodigo('');
    setSenha('');
    setPaginaProdutos(false);
  };

  // Página Unidades
  if (empresaSelecionada && paginaUnidades) {
    return <UnidadesPage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaUnidades(false)} onSair={handleSair} />;
  }

  // Página Grupos
  if (empresaSelecionada && paginaGrupos) {
    return <GruposPage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaGrupos(false)} onSair={handleSair} />;
  }

  // Página Produtos CRUD
  if (empresaSelecionada && paginaProdutosCrud) {
    return <ProdutosPage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaProdutosCrud(false)} onSair={handleSair} />;
  }

  // Página Produtos (intermediária)
  if (empresaSelecionada && paginaProdutos) {
    const cardsProdutos = [
      { nome: 'Unidades', icon: (
        <svg className="w-8 h-8 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" /></svg>
      ), onClick: () => setPaginaUnidades(true) },
      { nome: 'Grupos', icon: (
        <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /></svg>
      ), onClick: () => setPaginaGrupos(true) },
      { nome: 'Produtos', icon: (
        <svg className="w-8 h-8 mb-2 text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M8 8h8v8H8z" /></svg>
      ), onClick: () => setPaginaProdutosCrud(true) },
      { nome: 'Tabelas', icon: (
        <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M16 3v4M8 3v4" /></svg>
      ) },
      { nome: 'Grades', icon: (
        <svg className="w-8 h-8 mb-2 text-purple-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>
      ) },
      { nome: 'Adicionais', icon: (
        <svg className="w-8 h-8 mb-2 text-pink-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 8v8M8 12h8" /></svg>
      ) },
    ];
    return (
      <MenuProdutosPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        cardsProdutos={cardsProdutos}
        handleVoltar={handleVoltar}
        handleSair={handleSair}
      />
    );
  }

  // Página de login
  if (!usuario) {
    return (
      <LoginPage
        usrCodigo={usrCodigo}
        setUsrCodigo={setUsrCodigo}
        senha={senha}
        setSenha={setSenha}
        erro={erro}
        loading={loading}
        handleSubmit={handleSubmit}
      />
    );
  }

  // Página de seleção de empresa
  if (empresas.length > 0 && !empresaSelecionada) {
    if (empresas.length === 1) return null;
    // Filtrar apenas empresas ativas
    const empresasAtivas = empresas.filter(e => e.ativo !== false);
    // Ordenar: revenda = true primeiro, depois por fantasia
    const empresasOrdenadas = empresasAtivas.slice().sort((a, b) => {
      if (a.revenda === true && b.revenda !== true) return -1;
      if (a.revenda !== true && b.revenda === true) return 1;
      return (a.fantasia || '').localeCompare(b.fantasia || '', 'pt', { sensitivity: 'base' });
    });
    const empresasFiltradas = empresasOrdenadas.filter(e =>
      e.fantasia.toLowerCase().includes(pesquisaEmpresa.toLowerCase()) ||
      String(e.id).includes(pesquisaEmpresa)
    );
    const totalPaginasFiltradas = Math.ceil(empresasFiltradas.length / PAGE_SIZE);
    const empresasPaginadas = empresasFiltradas.slice((pagina - 1) * PAGE_SIZE, pagina * PAGE_SIZE);
    return (
      <SelecionarEmpresaPage
        usuario={usuario}
        empresas={empresas}
        pesquisaEmpresa={pesquisaEmpresa}
        setPesquisaEmpresa={setPesquisaEmpresa}
        pagina={pagina}
        setPagina={setPagina}
        empresasFiltradas={empresasFiltradas}
        empresasPaginadas={empresasPaginadas}
        totalPaginasFiltradas={totalPaginasFiltradas}
        handleSelecionarEmpresa={handleSelecionarEmpresa}
        handleSair={handleSair}
      />
    );
  }

  // Página MobTEF
  if (empresaSelecionada && paginaMobtef) {
    return (
      <RelatorioMobtefPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setPaginaMobtef(false)}
        handleSair={handleSair}
      />
    );
  }

  // Página MobTEF Planilha
  if (empresaSelecionada && paginaMobtefPlanilha) {
    return (
      <RelatorioMobtefPlanilhaPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setPaginaMobtefPlanilha(false)}
        handleSair={handleSair}
      />
    );
  }

  // Página Relatórios
  if (empresaSelecionada && paginaRelatorios) {
    return (
      <MenuRelatoriosPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setPaginaRelatorios(false)}
        handleSair={handleSair}
        onSelecionarRelatorio={(relatorio) => {
          if (relatorio === 'mobtef') setPaginaMobtef(true);
          else if (relatorio === 'mobtef_planilha') setPaginaMobtefPlanilha(true);
          else alert('Relatório selecionado: ' + relatorio);
        }}
      />
    );
  }

  // Página Atendimentos
  if (empresaSelecionada && paginaAtendimentos) {
    return (
      <AtendimentosPage
        empresa={empresaSelecionada}
        usuario={usuario}
        onVoltar={() => setPaginaAtendimentos(false)}
        onSair={handleSair}
      />
    );
  }

  // Página Pedidos
  if (empresaSelecionada && paginaPedidos) {
    return (
      <PedidosPage
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={() => setPaginaPedidos(false)}
        onSair={handleSair}
      />
    );
  }

  // Página Menu Vendas
  if (empresaSelecionada && paginaVendas) {
    return (
      <MenuVendasPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setPaginaVendas(false)}
        handleSair={handleSair}
        onSelecionarMenuVendas={(key) => {
          if (key === 'atendimentos') setPaginaAtendimentos(true);
          else if (key === 'pedidos') setPaginaPedidos(true);
          else alert('Selecionado: ' + key);
        }}
      />
    );
  }

  // Página Menu Configurações
  if (empresaSelecionada && paginaConfiguracoes) {
    return (
      <MenuConfiguracoesPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setPaginaConfiguracoes(false)}
        handleSair={handleSair}
      />
    );
  }

  // Página principal após seleção da empresa
  if (empresaSelecionada && !paginaProdutos && !paginaUnidades && !paginaGrupos && !paginaProdutosCrud && !paginaRelatorios && !paginaMobtef && !paginaMobtefPlanilha && !paginaVendas && !paginaAtendimentos && !paginaPedidos && !paginaConfiguracoes) {
    const cardsMenu = [
      { nome: 'Clientes', icon: (
        <svg className="w-8 h-8 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m9-4a4 4 0 11-8 0 4 4 0 018 0zm6 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a6 6 0 0112 0z" /></svg>
      ) },
      { nome: 'Produtos', icon: (
        <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16" /></svg>
      ), onClick: () => setPaginaProdutos(true) },
      { nome: 'Vendas', icon: (
        <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 3v18h18" /><path strokeLinecap="round" strokeLinejoin="round" d="M7 13l3 3 7-7" /></svg>
      ), onClick: () => setPaginaVendas(true) },
      { nome: 'Relatórios', icon: (
        <svg className="w-8 h-8 mb-2 text-purple-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-6a2 2 0 012-2h2a2 2 0 012 2v6" /><path strokeLinecap="round" strokeLinejoin="round" d="M13 7h-1V4a1 1 0 00-2 0v3H9" /></svg>
      ), onClick: () => setPaginaRelatorios(true) },
      { nome: 'Configurações', icon: (
        <svg className="w-8 h-8 mb-2 text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3" /><circle cx="12" cy="12" r="10" /></svg>
      ), onClick: () => setPaginaConfiguracoes(true) },
      { nome: 'Extras', icon: (
        <svg className="w-8 h-8 mb-2 text-pink-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h8" /></svg>
      ) },
    ];
    // Se só tem uma empresa, o Voltar faz logout
    const handleVoltarMenu = empresas.length === 1 ? handleSair : handleVoltar;
    return (
      <MenuPrincipalPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        cardsMenu={cardsMenu}
        handleVoltar={handleVoltarMenu}
        handleSair={handleSair}
      />
    );
  }

  // Não deve chegar aqui, pois todos os fluxos estão cobertos
  return null;
}

export default App;
